import axios from 'axios';
import router from '../../router/index.js';
import { Notification } from 'element-ui';
// 本地测试
// export const baseURL_1 = 'http://localhost:9003';
// 测试
// export const baseURL_1 = 'http://plat.vue.waiwubang.com/prod-api';
// 正式
export const baseURL_1 = 'http://platapi.vcjiayan.com';

const baseURL = baseURL_1 + '/api-card/';
axios.defaults.withCredentials = true;
let ceshi_url = "";

// ceshi_url = "01.duihuan.vcjiayan.com";
// ceshi_url = "onepc.vjiayan.com";


// post请求
async function postRequest(url, data) {
    let token = '';
    if (localStorage.token) {
        token = localStorage.token;
    }

    let res = await axios.post(baseURL + url, data, {
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            Authorization: token
        }
    });

    if (res.data.code === 200) {
        return Promise.resolve(res.data);
    } else if (res.code === 400) {
        router.push('/home');
    } else if (res.data.code === 500) {
        if (res.data.value) {
            Notification.warning(res.data.value)
        } else {
            Notification.warning(res.data.msg)
        }
    } else {
        console.log('-------------接口请求错误------------');
        console.log(res);
        console.log('-------------接口请求错误------------');
    }
}

// 不带token的post请求
async function postRequest2(url, data) {
    let res = await axios.post(baseURL + url, data);
    if (res.data.code === 200) {
        return Promise.resolve(res.data);
    } else if (res.code === 400) {
        router.push('/home');
    } else if (res.data.code === 500) {
        if (res.data.value) {
            Notification.warning(res.data.value)
        } else {
            Notification.warning(res.data.msg)
        }
    } else {
        console.log('-------------接口请求错误------------');
        console.log(res);
        console.log('-------------接口请求错误------------');
    }
}

// get请求
async function getRequest(url) {
    let token = localStorage.token || '';

    let res = await axios.get(baseURL + url, {
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            Authorization: token
        }
    });

    if (res.data.code === 200) {
        return Promise.resolve(res.data);
    } else if (res.code === 400) {
        router.push('/home');
    } else if (res.data.code === 500) {
        if (res.data.value) {
            Notification.warning(res.data.value)
        } else {
            Notification.warning(res.data.msg)
        }
    } else {
        console.log('-------------接口请求错误------------');
        console.log(res);
        console.log('-------------接口请求错误------------');
    }
}

// 不带token的get请求
async function getRequest2(url) {
    let res = await axios.get(baseURL + url);
    if (res.data.code === 200) {
        return Promise.resolve(res.data);
    } else if (res.code === 400) {
        router.push('/home');
    } else if (res.data.code === 500) {
        if (res.data.value) {
            Notification.warning(res.data.value)
        } else {
            Notification.warning(res.data.msg)
        }
    } else {
        console.log('-------------接口请求错误------------');
        console.log(res);
        console.log('-------------接口请求错误------------');
    }
}
// 不带token的get请求
async function getRequest3(url) {
    let res = await axios.get(baseURL + url);
    return Promise.resolve(res.data);
}




export const urlencode =(str) => {  
    str = (str + '').toString();   

    return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').  
    replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');  
}




// 1.登录
export const loginRequest = (data) => {
    return postRequest('login-customer', data);
};

// 2.站点baseInfo
export const baseInfoRequest2 = (url) => {
    return getRequest('api/daifa/config/info/' + url);
};

// 1.立即兑换请求
export const nowExchangeRequest = (data) => {
    return postRequest2('config/cardcheck', data);
};

// 2.订单查询请求
export const orderFindRequest = (data) => {
    return postRequest2('config/orderinfo', data);
};

// 3.短信验证码请求
export const phoneCodeRequest = (data) => {
    return postRequest2('config/getcodebycard', data);
};

// 4.获取首页轮播图请求
export const homeSwipereRequest = (data) => {
    return postRequest2('config/cardadvertlist', data);
};

// 5.获取站点基本信息
export const baseInfoRequest = (url) => {
    if (null != ceshi_url && typeof (ceshi_url) != "undefined" && ceshi_url != "") {
        url = ceshi_url;
    }
    return getRequest2('config/info/' + url);
};

// 6.获取首页大客户列表请求
export const homeLargeClientsRequest = (data) => {
    return postRequest2('config/bigclientlist', data);
};

// 7.获取大客户详情请求
export const getLargeClientsInfoRequest = (data) => {
    return postRequest2('config/bigclientinfo', data);
};

// 8.帮助中心1/2级分类请求
export const helperCenter1nd2Request = (data) => {
    return postRequest2('config/cardarticletypelist', data);
};

// 9.帮助中心内容请求
export const helperCenterTextRequest = (data) => {
    return postRequest2('config/cardarticleinfo', data);
};

// 10.cardInfoRequest
export const cardInfoRequest = (data) => {
    return postRequest('card/cardtype', data);
};

// 11.卡型下套餐请求
export const cardInterTCRequest = (url, data) => {
    return postRequest(url, data);
};

// 12.卡型下公告列表请求
export const cardInterGGListRequest = (data) => {
    return postRequest('card/cardtypenoticelist', data);
};

// 13.商品详情请求
export const goodsDetailRequest = (data) => {
    return postRequest('card/goodsinfo', data);
};

// 14.套餐详情请求
export const TCDetailRequest = (data) => {
    return postRequest('card/setmealinfo', data);
};

// 15.商品列表请求
export const goodsListlRequest = (data) => {
    return postRequest('card/goodslist', data);
};

// 16.确认兑换请求
export const submitExchangeRequest = (data) => {
    return postRequest('order/add-duihuan', data);
};

// 17.卡型下公告列表->公告详情请求
export const cardInterGGDetailRequest = (data) => {
    return postRequest('card/cardtypenoticeinfo', data);
};

// 18.套餐下公告列表请求
export const TCInterGGListRequest = (data) => {
    return postRequest('card/setmealnoticelist', data);
};

//地址
export const countryRequest = (data) => {
    return getRequest3('config/cityinfo/1', data);
};

// 19.套餐下公告列表>公告详情请求
export const TCInterGGDetailRequest = (data) => {
    return postRequest('card/setmealnoticeinfo', data);
};

// 20.验证手机号，获取token
export const noCardsOnlyHavedPhone = (data) => {
    return postRequest2('config/orderinfo5', data);
};

// 21.获取手机号下卡号列表
export const getPhoneHaveCardsInfo = (data) => {
    return postRequest('card/cardbindphonelist', data);
};

// 22.选中手机号下卡号
export const choosePhoneHaveCards = (data) => {
    return postRequest('card/cardbindphoneselected', data);
};

// 23.订单查询请求2
export const orderFindRequest2 = (data) => {
    return postRequest('card/orderinfo2', data);
};
// 24.获取定制页列详情
export const cardCustomizedInfoRequest = (data) => {
    return postRequest2('config/cardcustomizedinfo', data);
};
// 24.获取定制页广告列表
export const cardCustomizedAdvertListRequest = (data) => {
    return postRequest2('config/cardcustomizedadvertlist', data);
};
